export const getType = (variable) => {
    return Object.prototype.toString.call(variable).slice(8, -1);
}

export const checkType = (type) => {
    return function (variable) {
        return getType(variable) === type;
    };
}

export const checkTypeExplicit = (type, variable) => {
    return getType(variable) === type;
}


export const checkArgumentsExplicit = (types, args) => {
    var args = Array.prototype.slice.call(args);
    if (args.length !== types.length) {
        throw new Error("Arguments length does not match types length");
    }
    if (args.length === 0) {
        throw new Error("No arguments or types supplied");
    }
    args.forEach(function (arg, i) {
        if (!checkTypeExplicit(arg, types[i])) {
            throw new TypeError("argument: " + arg + " is not type: " + types[i]);
        }
    });
}

export const isUndefined = (variable: any) => {
  return typeof variable === 'undefined';
}

export const isNull = (variable: any) => {
  return variable === null;
}

export const isUndefinedOrNull = (variable: any) => {
  return isUndefined(variable) || isNull(variable);
}

export const notNull = (variable: any) => {
  return variable !== null;
}

export const notUndefined = (variable: any) => {
  return typeof variable !== 'undefined';
}

export const notUndefinedNotNull = (variable: any) => {
  return notUndefined(variable) && notNull(variable);
}

export const isJsonEqual = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b); 
}